import { IFormatVersion } from "./FormatVersion";

export interface IFormatParameter {
    id: string;
    tag: string;
    description: string;
    value: string;

    file?: File;

    formatVersionId: string;
    formatVersion: IFormatVersion;
    formatParameterType: string;
    isReplaceableValue: boolean;
}

export class FormatParameter implements IFormatParameter {
    id: string;
    tag: string;
    description: string;
    value: string;

    file?: File;

    formatVersionId: string;
    formatVersion: IFormatVersion;
    formatParameterType: string;
    isReplaceableValue: boolean;

    constructor();
    constructor(obj: IFormatParameter);
    constructor(obj?: IFormatParameter) {
        this.id = obj?.id ?? undefined;
        this.tag = obj?.tag ?? undefined;
        this.description = obj?.description ?? undefined;
        this.value = obj?.value ?? undefined;
        this.file = obj?.file ?? undefined;
        this.formatVersionId = obj?.formatVersionId ?? undefined;
        this.formatVersion = obj?.formatVersion ?? undefined;
        this.formatParameterType = obj?.formatParameterType ?? undefined;
        this.isReplaceableValue = obj?.isReplaceableValue ?? true;
    }
}